import { render, staticRenderFns } from "./client-details.pug?vue&type=template&id=97f9f1f0&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./client-details.scss?vue&type=style&index=0&id=97f9f1f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f9f1f0",
  null
  
)

export default component.exports